<template>
  <div class="banner-container">
    <div class="banner" :style="{ backgroundImage: getBackgroundImageValue(fileName) }" />
  </div>
</template>

<script>
const getBackgroundImageValue = fileName => {
  return fileName ? `url('https://pointsmap.com/images/uploads/${fileName}')` : 'none'
}

export default {
  name: "HomeBanner.vue",
  props: {
    fileName: String,
  },
  setup() {
    return {
      getBackgroundImageValue
    }
  },
}
</script>

<style scoped>
.banner-container {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.banner-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: v-bind('getBackgroundImageValue(fileName)');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  filter: blur(8px);
  z-index: 0;
}

.banner {
  position: relative;
  background-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  color: #111;
  height: 100%;
  width: 100%;
}
</style>
